module.exports = __webpack_public_path__ + "img/labourServices.84b7c85e.png";